/* SETTE: Made for You (the November 6 edit).
   The quick add sheet below is the collection grid's (Product Grid Q4 2026), shown as a
   bottom sheet on phones and a centered panel on desktop. Then the page's own behavior:
   hearts and the wishlist, the send / bag bar, the countdown, the rail, reviews, and the initial picker. */
(function () {
  if (window.__setteMfy) return;
  window.__setteMfy = true;

    var C = {
      qa: 'sg-qa-mfy',
      panel: 'sg-panel-mfy',
      grab: 'sg-grab-mfy',
      head: 'sg-head-mfy',
      thumb: 'sg-thumb-mfy',
      headText: 'sg-head-text-mfy',
      headTitle: 'sg-head-title-mfy',
      headSub: 'sg-head-sub-mfy',
      ship: 'sg-ship-mfy',
      headSide: 'sg-head-side-mfy',
      headPrice: 'sg-head-price-mfy',
      close: 'sg-close-mfy',
      opt: 'sg-opt-mfy',
      optLabel: 'sg-opt-label-mfy',
      swatches: 'sg-swatches-mfy',
      sw: 'sg-sw-mfy',
      swRing: 'sg-sw-ring-mfy',
      swDot: 'sg-sw-dot-mfy',
      chips: 'sg-chips-mfy',
      chip: 'sg-chip-mfy',
      dd: 'sg-dd-mfy',
      ddBtn: 'sg-dd-btn-mfy',
      ddList: 'sg-dd-list-mfy',
      ddOpt: 'sg-dd-opt-mfy',
      foot: 'sg-foot-mfy',
      add: 'sg-add-mfy',
      error: 'sg-error-mfy',
      trust: 'sg-trust-mfy',
      details: 'sg-details-mfy',
      lock: 'sg-lock-mfy'
    };

    var CHECK_SVG = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
    var CLOSE_SVG = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18"/></svg>';
    var CHEVRON_SVG = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M6 9l6 6 6-6"/></svg>';

    function rootUrl() {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      return root.charAt(root.length - 1) === '/' ? root : root + '/';
    }

    function formatMoney(cents) {
      var format = (window.theme && window.theme.moneyFormat) || '${{amount_no_decimals}}';
      var amount = (Number(cents) || 0) / 100;
      return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (match, key) {
        if (key === 'amount_no_decimals' || key === 'amount_no_decimals_with_comma_separator') {
          return Math.round(amount).toLocaleString('en-US');
        }
        return amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      });
    }

    function el(tag, className, text) {
      var node = document.createElement(tag);
      if (className) node.className = className;
      if (text != null) node.textContent = text;
      return node;
    }

    function isDesktop() {
      return window.matchMedia('(min-width: 750px)').matches;
    }

    function isMetal(name) {
      return /metal|colou?r|material|finish/i.test(name || '');
    }

    function isSize(name) {
      // Ring size, bracelet length. Not stone size or carat ("Emerald Lab Diamond Size").
      return /size|length/i.test(name || '') && !/diamond|stone|carat|\bct\b|cttw|gem/i.test(name || '');
    }

    // Same wording as the cart drawer: "In stock." or "Made to order." plus the
    // ships-in text from inside the brackets of the Made-to-order field.
    function shipsLine(raw) {
      raw = (raw || '').trim();
      if (!raw) return null;
      var stock = /in\s*stock/i.test(raw);
      var match = raw.match(/[\(\[]([^\)\]]+)[\)\]]/);
      var detail = match ? match[1].trim() : '';
      if (detail) {
        detail = detail.charAt(0).toUpperCase() + detail.slice(1);
        if (!/[.!]$/.test(detail)) detail += '.';
      }
      return { stock: stock, status: stock ? 'In stock.' : 'Made to order.', detail: detail };
    }

    function swatchFill(name, value, base) {
      var v = (value || '').toLowerCase();
      var gradient = 'radial-gradient(circle at 32% 30%, #e9e9e9 0%, #d6d6d6 60%, #bdbdbd 100%)';
      if (/rose|pink/.test(v)) gradient = 'radial-gradient(circle at 32% 30%, #fbe2d6 0%, #eab7a0 50%, #c98b72 100%)';
      else if (/white|silver|platinum|sterling/.test(v)) gradient = 'radial-gradient(circle at 32% 30%, #ffffff 0%, #e9e9e9 50%, #bdbdbd 100%)';
      else if (/yellow|gold/.test(v)) gradient = 'radial-gradient(circle at 32% 30%, #fbf1b8 0%, #ecd27a 45%, #cfa847 100%)';
      if (!base) return gradient;
      // Swatch King stores its swatch images by option name and value.
      var url = base.replace(/\/$/, '') + '/' + encodeURIComponent(encodeURIComponent(name)) +
        '/100/' + encodeURIComponent(encodeURIComponent(value)) + '.webp';
      return 'url("' + url + '"), ' + gradient;
    }

    var productCache = {};
    function getProduct(handle) {
      if (productCache[handle]) return productCache[handle];
      productCache[handle] = fetch(rootUrl() + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
        .then(function (r) {
          if (!r.ok) throw new Error('Product not found');
          return r.json();
        })
        .catch(function (err) {
          delete productCache[handle];
          throw err;
        });
      return productCache[handle];
    }

    function addToCart(variantId) {
      const controller = window.AbortController ? new AbortController() : null;
      const timer = setTimeout(function () { if (controller) controller.abort(); }, 10000);
      return fetch(rootUrl() + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
        signal: controller ? controller.signal : undefined
      }).then(function (r) {
        return r.text().then(function (text) {
          let data = null;
          try { data = JSON.parse(text); } catch (e) { data = null; }
          if (!r.ok || (data && data.status && data.description)) {
            throw new Error((data && (data.description || data.message)) || 'Could not add to bag. Please try again.');
          }
          return data;
        });
      }).catch(function (err) {
        if (err && err.name === 'AbortError') throw new Error('The bag is taking a while to respond. Please try again.');
        throw err;
      }).finally(function () {
        clearTimeout(timer);
      });
    }

    // Hand off to the SETTE cart drawer: it shows its loading state on
    // "cart:refresh" and fetches the new bag, the same as the product page.
    function openBag(trigger) {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      const drawer = document.querySelector('cart-drawer');
      try {
        if (drawer && typeof drawer.open === 'function') {
          drawer.open(trigger);
          return;
        }
      } catch (e) {}
      window.location.href = rootUrl() + 'cart';
    }


    class SetteMfyShop extends HTMLElement {
      connectedCallback() {
        if (this.__sgBound) return;
        this.__sgBound = true;
        document.addEventListener('click', (e) => {
          const qa = e.target.closest && e.target.closest('[data-sg-qa]');
          if (qa) { e.preventDefault(); this.quickAdd(qa); return; }
          if (e.target.closest && e.target.closest('[data-sg-scrim]')) this.closePanel();
        });
        document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && this.openState) this.closePanel(); });
        document.addEventListener('pointerover', (e) => {
          const qa = e.target && e.target.closest && e.target.closest('[data-sg-qa]');
          if (!qa) return;
          const card = qa.closest('[data-sg-card]');
          if (card && card.dataset.handle && !card.dataset.variantId) getProduct(card.dataset.handle).catch(function () {});
        }, { passive: true });
      }

      label(key, fallback) {
        return this.dataset[key] || fallback;
      }

      flashBar(bar, state, text) {
        if (!bar) return;
        clearTimeout(bar.__sgTimer);
        const original = bar.getAttribute('data-label');
        bar.classList.remove('is-loading', 'is-added');
        if (state === 'added') {
          bar.classList.add('is-added');
          bar.innerHTML = CHECK_SVG + '<span></span>';
          bar.querySelector('span').textContent = text;
        } else {
          bar.textContent = text;
        }
        bar.__sgTimer = setTimeout(function () {
          bar.classList.remove('is-added');
          bar.textContent = original;
        }, 1800);
      }

      quickAdd(bar) {
        const card = bar.closest('[data-sg-card]');
        if (!card) return;
        if (this.openState && this.openState.card === card) {
          this.closePanel();
          return;
        }

        // Designs with a single variant add straight away.
        if (card.dataset.variantId) {
          this.add(card.dataset.variantId, card, bar, null);
          return;
        }

        bar.classList.add('is-loading');
        getProduct(card.dataset.handle)
          .then((product) => {
            bar.classList.remove('is-loading');
            const ctx = this.context(card, product);
            if (ctx.direct) {
              const variant = ctx.exact();
              if (variant && variant.available) {
                this.add(variant.id, card, bar, null);
                return;
              }
            }
            this.openPanel(card, product, ctx, bar);
          })
          .catch(function () {
            bar.classList.remove('is-loading');
            if (card.dataset.url) window.location.href = card.dataset.url;
          });
      }

      // Which variant the card is showing. Swatch King marks the chosen swatch
      // (data-value) and links the card to the chosen variant.
      cardVariant(card, product, metalIdx) {
        if (metalIdx >= 0) {
          const chosen = card.querySelector('variant-swatch-king .swatch-selected[data-value], .swatch-king-container .swatch-selected[data-value], .swatch-selected[data-value]');
          const text = chosen ? (chosen.getAttribute('data-value') || '').trim().toLowerCase() : '';
          if (text) {
            const byValue = product.variants.find(function (v) {
              return v.available && String(v.options[metalIdx] || '').toLowerCase() === text;
            });
            if (byValue) return byValue;
          }
        }
        const links = card.querySelectorAll('a[href*="variant="]');
        for (let i = 0; i < links.length; i++) {
          const m = links[i].getAttribute('href').match(/variant=(\d+)/);
          if (m) {
            const found = product.variants.find(function (v) { return String(v.id) === m[1]; });
            if (found) return found;
          }
        }
        return null;
      }

      context(card, product) {
        const names = product.options.map(function (o) { return typeof o === 'string' ? o : o.name; });
        const values = product.options.map(function (o, i) {
          if (o && o.values) return o.values;
          const seen = [];
          product.variants.forEach(function (v) {
            if (seen.indexOf(v.options[i]) === -1) seen.push(v.options[i]);
          });
          return seen;
        });
        let metalIdx = -1;
        names.forEach(function (n, i) { if (metalIdx < 0 && isMetal(n) && values[i].length > 1) metalIdx = i; });
        const firstAvailable = product.variants.filter(function (v) { return v.available; })[0] || product.variants[0];
        const fromCard = this.cardVariant(card, product, metalIdx);

        // One-value options are set. Sizes wait for her choice. Metal follows
        // the card; anything else starts on the first available combination.
        const selected = names.map(function (name, i) {
          if (values[i].length === 1) return values[i][0];
          if (isSize(name)) return null;
          if (i === metalIdx && fromCard) return fromCard.options[i];
          return firstAvailable ? firstAvailable.options[i] : null;
        });

        function matches(variant, sel) {
          for (let i = 0; i < sel.length; i++) {
            if (sel[i] !== null && variant.options[i] !== sel[i]) return false;
          }
          return true;
        }

        // Add straight away only when the design has a single variant.
        // Anything with a choice (even just metal) opens the options panel.
        const direct = product.variants.length < 2;

        return {
          names: names,
          values: values,
          metalIdx: metalIdx,
          selected: selected,
          direct: direct,
          matches: matches,
          exact: function () {
            if (selected.indexOf(null) !== -1) return null;
            return product.variants.find(function (v) { return matches(v, selected); }) || null;
          }
        };
      }

      add(variantId, card, bar, addBtn) {
        const self = this;
        if (this.adding) return;
        this.adding = true;
        if (bar) bar.classList.add('is-loading');
        if (addBtn) {
          addBtn.classList.add('is-loading');
          addBtn.disabled = true;
          addBtn.textContent = this.label('labelAdding', 'Adding');
        }
        return addToCart(variantId)
          .then(function (item) {
            self.adding = false;
            // Always close the panel and confirm, even if something below fails.
            try { self.closePanel(true); } catch (e) {}
            try { self.flashBar(bar, 'added', self.label('labelAdded', 'Added')); } catch (e) {}
            try {
              document.dispatchEvent(new CustomEvent('sette:quick-add', {
                detail: { variantId: Number(variantId), handle: card && card.dataset.handle, item: item }
              }));
            } catch (e) {}
            openBag(bar);
          })
          .catch(function (err) {
            self.adding = false;
            if (bar) bar.classList.remove('is-loading');
            const message = (err && err.message) || 'Something went wrong. Please try again.';
            if (addBtn && self.openState) {
              const panel = self.querySelector('[data-sg-panel]');
              const errorEl = panel && panel.querySelector('[data-sg-error]');
              if (errorEl) {
                errorEl.textContent = message;
                errorEl.hidden = false;
              }
              if (self.openState.update) self.openState.update();
            } else {
              self.flashBar(bar, 'error', 'Try again');
            }
          });
      }

      /* ---------------- Options panel ---------------- */

      openPanel(card, product, ctx, trigger) {
        this.closePanel(true);
        const panel = this.querySelector('[data-sg-panel]');
        const scrim = this.querySelector('[data-sg-scrim]');
        if (!panel) return;

        const self = this;
        const incard = false;
        const selected = ctx.selected;
        const names = ctx.names;
        const values = ctx.values;
        const d = card.dataset;
        const sizeLabel = this.label('labelSize', 'Select a Size');

        panel.innerHTML = '';
        panel.setAttribute('aria-label', 'Choose options for ' + product.title);

        let priceEl = null;
        let detailsEl = null;
        const closeBtn = el('button', C.close);
        closeBtn.type = 'button';
        closeBtn.setAttribute('aria-label', 'Close');
        closeBtn.innerHTML = CLOSE_SVG;
        closeBtn.addEventListener('click', function () { self.closePanel(); });

        if (!incard) {
          panel.appendChild(el('span', C.grab));
          const head = el('div', C.head);
          if (d.image) {
            const thumb = el('img', C.thumb);
            thumb.src = d.image;
            thumb.alt = '';
            thumb.width = 64;
            thumb.height = 64;
            head.appendChild(thumb);
          }
          const text = el('div', C.headText);
          text.appendChild(el('p', C.headTitle, product.title));
          if (d.subtitle) text.appendChild(el('p', C.headSub, d.subtitle));
          const ships = shipsLine(d.ships);
          if (ships) {
            const shipEl = el('p', C.ship + (ships.stock ? ' is-stock' : ''));
            shipEl.appendChild(el('strong', null, ships.status));
            if (ships.detail) shipEl.appendChild(document.createTextNode(' ' + ships.detail));
            text.appendChild(shipEl);
          }
          if (this.dataset.note) text.appendChild(el('p', C.ship + ' mfy-note', this.dataset.note));
          head.appendChild(text);
          const side = el('div', C.headSide);
          side.appendChild(closeBtn);
          priceEl = el('p', C.headPrice);
          side.appendChild(priceEl);
          head.appendChild(side);
          panel.appendChild(head);
        } else {
          panel.appendChild(closeBtn);
        }

        const groups = [];
        const dropdowns = [];

        function closeDropdowns(except) {
          dropdowns.forEach(function (dd) {
            if (dd === except) return;
            dd.list.hidden = true;
            dd.button.setAttribute('aria-expanded', 'false');
          });
        }

        names.forEach(function (name, i) {
          if (values[i].length < 2) return;
          const group = el('div', C.opt);

          if (i === ctx.metalIdx) {
            // Swatch King metal swatches: "Metal Type : 18K Yellow Gold"
            const label = el('p', C.optLabel);
            label.appendChild(el('b', null, name));
            const chosen = el('span');
            label.appendChild(chosen);
            group.appendChild(label);
            const row = el('div', C.swatches);
            row.setAttribute('role', 'group');
            row.setAttribute('aria-label', name);
            const buttons = values[i].map(function (value) {
              const b = el('button', C.sw);
              b.type = 'button';
              b.setAttribute('aria-label', value);
              const ring = el('span', C.swRing);
              const dot = el('span', C.swDot);
              dot.style.backgroundImage = swatchFill(name, value, self.dataset.swatchBase);
              ring.appendChild(dot);
              b.appendChild(ring);
              b.addEventListener('click', function () { selected[i] = value; update(); });
              row.appendChild(b);
              return { value: value, node: b };
            });
            group.appendChild(row);
            groups.push({ kind: 'swatch', index: i, chosen: chosen, buttons: buttons });
          } else if (isSize(name)) {
            // Swatch King dropdown: "Ring Size: 3.5"
            const wrap = el('div', C.dd);
            const button = el('button', C.ddBtn);
            button.type = 'button';
            button.setAttribute('aria-haspopup', 'listbox');
            button.setAttribute('aria-expanded', 'false');
            const text = el('span');
            text.appendChild(el('b', null, name + ':'));
            text.appendChild(document.createTextNode(' '));
            const val = el('i');
            text.appendChild(val);
            button.appendChild(text);
            button.insertAdjacentHTML('beforeend', CHEVRON_SVG);
            const list = el('div', C.ddList);
            list.setAttribute('role', 'listbox');
            list.setAttribute('aria-label', name);
            list.hidden = true;
            const options = values[i].map(function (value) {
              const o = el('button', C.ddOpt, value);
              o.type = 'button';
              o.setAttribute('role', 'option');
              o.addEventListener('click', function () {
                selected[i] = value;
                list.hidden = true;
                button.setAttribute('aria-expanded', 'false');
                update();
                button.focus({ preventScroll: true });
              });
              list.appendChild(o);
              return { value: value, node: o };
            });
            const dd = { button: button, list: list };
            dropdowns.push(dd);
            button.addEventListener('click', function () {
              const open = list.hidden;
              closeDropdowns(dd);
              list.hidden = !open;
              button.setAttribute('aria-expanded', open ? 'true' : 'false');
              if (open) {
                const current = list.querySelector('[aria-selected="true"]') || list.querySelector('button:not(:disabled)');
                if (current) current.scrollIntoView({ block: 'nearest' });
              }
            });
            wrap.appendChild(button);
            wrap.appendChild(list);
            group.appendChild(wrap);
            groups.push({ kind: 'dropdown', index: i, name: name, value: val, buttons: options });
          } else {
            // Swatch King buttons: "Bundle" Single Earring / Pair (2)
            const label = el('p', C.optLabel);
            label.appendChild(el('b', null, name));
            group.appendChild(label);
            const row = el('div', C.chips);
            row.setAttribute('role', 'group');
            row.setAttribute('aria-label', name);
            const buttons = values[i].map(function (value) {
              const b = el('button', C.chip, value);
              b.type = 'button';
              b.addEventListener('click', function () { selected[i] = value; update(); });
              row.appendChild(b);
              return { value: value, node: b };
            });
            group.appendChild(row);
            groups.push({ kind: 'chip', index: i, buttons: buttons });
          }
          panel.appendChild(group);
        });

        const foot = el('div', C.foot);
        const addBtn = el('button', C.add);
        addBtn.type = 'button';
        foot.appendChild(addBtn);
        const errorEl = el('p', C.error);
        errorEl.setAttribute('data-sg-error', '');
        errorEl.setAttribute('role', 'alert');
        errorEl.hidden = true;
        foot.appendChild(errorEl);
        if (this.dataset.trust) foot.appendChild(el('p', C.trust, this.dataset.trust));
        if (!incard && this.dataset.labelDetails) {
          detailsEl = el('a', C.details, this.dataset.labelDetails);
          detailsEl.href = d.url || '#';
          foot.appendChild(detailsEl);
        }
        panel.appendChild(foot);

        function update() {
          groups.forEach(function (g) {
            if (g.kind === 'swatch') g.chosen.textContent = selected[g.index] ? ' : ' + selected[g.index] : '';
            if (g.kind === 'dropdown') {
              const v = selected[g.index];
              g.value.textContent = v || 'Select your size';
              g.value.classList.toggle('is-empty', !v);
            }
            g.buttons.forEach(function (b) {
              const trial = selected.slice();
              trial[g.index] = b.value;
              const possible = product.variants.some(function (v) { return v.available && ctx.matches(v, trial); });
              const on = selected[g.index] === b.value;
              b.node.disabled = !possible;
              b.node.classList.toggle('is-selected', on);
              if (g.kind === 'dropdown') b.node.setAttribute('aria-selected', on ? 'true' : 'false');
              else b.node.setAttribute('aria-pressed', on ? 'true' : 'false');
            });
          });

          const variant = ctx.exact();
          if (priceEl) {
            priceEl.textContent = '';
            if (variant && variant.compare_at_price && variant.compare_at_price > variant.price) {
              priceEl.appendChild(el('s', null, formatMoney(variant.compare_at_price)));
            }
            priceEl.appendChild(document.createTextNode(
              variant ? formatMoney(variant.price) : (product.price_varies ? 'From ' : '') + formatMoney(product.price_min || product.price)
            ));
          }
          if (detailsEl) {
            detailsEl.href = (d.url || '#').split('?')[0] + (variant ? '?variant=' + variant.id : '');
          }

          addBtn.classList.remove('is-loading');
          if (variant && variant.available) {
            addBtn.disabled = false;
            addBtn.textContent = self.label('labelAdd', 'Add to Bag') + ' · ' + formatMoney(variant.price);
          } else if (variant) {
            addBtn.disabled = true;
            addBtn.textContent = 'Sold Out';
          } else {
            addBtn.disabled = true;
            const missing = names.filter(function (n, i) { return selected[i] === null; })[0];
            addBtn.textContent = missing && isSize(missing) ? sizeLabel : 'Select ' + (missing || 'Options');
          }
        }

        addBtn.addEventListener('click', function () {
          const variant = ctx.exact();
          if (!variant || !variant.available) return;
          errorEl.hidden = true;
          self.add(variant.id, card, trigger, addBtn);
        });

        update();

        if (incard) {
          const media = card.querySelector('[data-sg-media]');
          media.appendChild(panel);
          panel.classList.add('is-incard');
          card.classList.add('is-qa-open');
        } else {
          if (scrim) scrim.hidden = false;
          document.documentElement.classList.add(C.lock);
        }
        panel.hidden = false;
        if (trigger) trigger.setAttribute('aria-expanded', 'true');
        this.openState = { card: card, trigger: trigger, incard: incard, update: update };

        const first = panel.querySelector('.' + C.ddBtn + ', .' + C.chip + ':not(:disabled), .' + C.sw + ':not(:disabled)') || addBtn;
        first.focus({ preventScroll: true });
      }

      closePanel(silent) {
        const state = this.openState;
        this.openState = null;
        // Always put the page back, even if the panel state was lost.
        const panel = this.querySelector('[data-sg-panel]');
        const scrim = this.querySelector('[data-sg-scrim]');
        if (panel) {
          panel.hidden = true;
          panel.classList.remove('is-incard');
          panel.innerHTML = '';
          if (panel.parentNode !== this) this.appendChild(panel);
        }
        if (scrim) scrim.hidden = true;
        document.documentElement.classList.remove(C.lock);
        const open = this.querySelectorAll('.is-qa-open');
        for (let i = 0; i < open.length; i++) open[i].classList.remove('is-qa-open');
        if (!state) return;
        if (state.trigger) {
          state.trigger.setAttribute('aria-expanded', 'false');
          if (!silent && document.body.contains(state.trigger)) state.trigger.focus({ preventScroll: true });
        }
      }

    }

    if (!window.customElements.get('sette-mfy-shop')) window.customElements.define('sette-mfy-shop', SetteMfyShop);

    /* =====================================================================
       Made for You page behavior (everything below is page-only)
       ===================================================================== */

    var LIST_KEY = 'sette-mfy-list-v1';
    var FINE = window.matchMedia('(hover: hover) and (pointer: fine)');

    function money(cents) { return formatMoney(cents); }
    function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
    function pad2(x) { return String(x).padStart(2, '0'); }

    /* ---------- Cutoff and countdown ---------- */
    function cutoffMs() {
      var host = document.querySelector('[data-mfy-cutoff]');
      var raw = host ? host.getAttribute('data-mfy-cutoff') : '';
      var t = Date.parse(raw);
      return isNaN(t) ? null : t;
    }
    function timeLeft() {
      var target = cutoffMs();
      if (target === null) return null;
      var diff = target - Date.now();
      var mins = Math.max(0, Math.floor(diff / 60000));
      return {
        diff: diff,
        open: diff > 0,
        final: diff > 0 && diff <= 72 * 3600000,
        d: Math.floor(mins / 1440),
        h: Math.floor((mins % 1440) / 60),
        m: mins % 60
      };
    }
    function barCount() {
      var t = timeLeft();
      if (!t || !t.open) return 'Made to order';
      if (t.final) return 'Ends in ' + t.d + 'd ' + t.h + 'h ' + t.m + 'm';
      return t.d + (t.d === 1 ? ' day' : ' days') + ' left to order';
    }
    function renderCountdown() {
      var t = timeLeft();
      qsa('[data-mfy-countdown]').forEach(function (band) {
        var show = !!t && t.final;
        band.hidden = !show;
        if (!show) return;
        band.querySelector('[data-cd="d"]').textContent = pad2(t.d);
        band.querySelector('[data-cd="h"]').textContent = pad2(t.h);
        band.querySelector('[data-cd="m"]').textContent = pad2(t.m);
      });
    }

    /* ---------- Media: image 1 / image 2 with the slide bar ---------- */
    function setFlip(media, on) {
      media.classList.toggle('is-flipped', on);
      var btn = media.querySelector('.mfy-media__flip');
      if (btn) btn.setAttribute('aria-label', on ? (btn.dataset.label1 || 'Show the first image') : (btn.dataset.label2 || 'Show the second image'));
      qsa('video', media).forEach(function (v) {
        if (on) { try { v.play(); } catch (e) {} }
      });
    }
    function bindMedia(media) {
      if (media.__mfy) return;
      media.__mfy = true;
      var hasTwo = media.hasAttribute('data-mfy-two');
      var isTile = !!media.closest('.mfy-tile');
      var flip = media.querySelector('.mfy-media__flip');
      if (flip) flip.addEventListener('click', function () {
        if (isTile && FINE.matches && media.dataset.url) { window.location.href = media.dataset.url; return; }
        if (hasTwo) setFlip(media, !media.classList.contains('is-flipped'));
      });
      if (!hasTwo) return;
      if (isTile) {
        media.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') setFlip(media, true); });
        media.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') setFlip(media, false); });
      }
      var x0 = null, y0 = null;
      media.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
      media.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
        x0 = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) setFlip(media, dx < 0);
      }, { passive: true });
    }

    /* ---------- Swatches on tiles ---------- */
    function paintSwatches(root) {
      var host = document.querySelector('sette-mfy-shop');
      var base = host ? host.dataset.swatchBase : '';
      qsa('.mfy-sw', root).forEach(function (sw) {
        var dot = sw.querySelector('span');
        if (dot && !dot.style.backgroundImage) dot.style.backgroundImage = swatchFill(sw.dataset.option, sw.dataset.value, base);
      });
    }
    function pickSwatch(sw) {
      var tile = sw.closest('.mfy-tile');
      if (!tile) return;
      qsa('.mfy-sw', tile).forEach(function (o) {
        var on = o === sw;
        o.classList.toggle('swatch-selected', on);
        o.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      var img = tile.querySelector('.mfy-media__slide--1');
      if (img && sw.dataset.img) { img.src = sw.dataset.img; img.removeAttribute('srcset'); }
      var link = tile.querySelector('.mfy-tile__name');
      if (link && sw.dataset.variant) link.href = tile.dataset.url + '?variant=' + sw.dataset.variant;
      var heart = tile.querySelector('[data-mfy-heart]');
      if (heart) heart.dataset.detail = sw.dataset.value;
    }

    /* ---------- Wishlist ---------- */
    function readList() {
      try { var v = JSON.parse(localStorage.getItem(LIST_KEY) || '[]'); return Array.isArray(v) ? v : []; } catch (e) { return []; }
    }
    var list = readList();
    function saveList() { try { localStorage.setItem(LIST_KEY, JSON.stringify(list)); } catch (e) {} }
    function onList(key) { return list.some(function (x) { return x.key === key; }); }
    function syncHearts() {
      qsa('[data-mfy-heart]').forEach(function (h) {
        var on = onList(h.dataset.key);
        h.classList.toggle('is-on', on);
        h.setAttribute('aria-pressed', on ? 'true' : 'false');
        h.setAttribute('aria-label', (on ? 'Remove ' : 'Add ') + h.dataset.title + (on ? ' from your wishlist' : ' to your wishlist'));
      });
    }
    function toggleHeart(h) {
      var key = h.dataset.key;
      if (onList(key)) {
        list = list.filter(function (x) { return x.key !== key; });
        toast(false);
      } else {
        list.push({
          key: key,
          title: h.dataset.title,
          detail: (h.dataset.detail ? h.dataset.detail + ' · ' : '') + 'Made to order',
          price: Number(h.dataset.price) || 0,
          from: h.dataset.from === 'true',
          url: h.dataset.url
        });
        toast(true);
      }
      saveList();
      syncHearts();
      renderBar();
    }

    /* ---------- Sticky bar ---------- */
    var bar, cart = null, sendMode = null, toastTimer = null, justAdded = null, justTimer = null;
    function listTotal() { return list.reduce(function (a, x) { return a + (x.price || 0); }, 0); }
    function message() {
      var intro = (bar && bar.dataset.messageIntro) || 'The SETTE designs I want.';
      var origin = window.location.origin;
      var lines = list.map(function (x) {
        var url = /^https?:/.test(x.url) ? x.url : origin + x.url;
        return x.title + ' (' + x.detail + '), ' + (x.from ? 'from ' : '') + money(x.price) + '\n' + url;
      });
      return intro + '\n\n' + lines.join('\n\n');
    }
    function sendHref(mode) {
      var body = encodeURIComponent(message());
      if (mode === 'email') return 'mailto:?subject=' + encodeURIComponent((bar && bar.dataset.subject) || 'The SETTE designs I want') + '&body=' + body;
      return 'sms:?&body=' + body;
    }
    function toast(added) {
      if (!bar) return;
      var t = bar.querySelector('[data-mfy-toast]');
      if (!t) return;
      t.querySelector('[data-mfy-toast-title]').textContent = added ? 'Added to your wishlist' : 'Removed from your wishlist';
      t.querySelector('.mfy-toast__pill').classList.toggle('is-on', added);
      t.hidden = !!sendMode;
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () { t.hidden = true; }, 3200);
    }
    function renderSend() {
      var send = bar.querySelector('[data-mfy-send]');
      if (!send) return;
      send.hidden = !sendMode;
      qsa('[data-mfy-open]', bar).forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.mfyOpen === sendMode ? 'true' : 'false'); });
      if (!sendMode) return;
      var toastEl = bar.querySelector('[data-mfy-toast]');
      if (toastEl) toastEl.hidden = true;
      send.querySelector('[data-mfy-send-eyebrow]').textContent = sendMode === 'email' ? 'Email your list' : 'Text your list';
      var empty = list.length === 0;
      send.querySelector('.mfy-empty').hidden = !empty;
      send.querySelector('.mfy-full').hidden = empty;
      var box = send.querySelector('[data-mfy-send-list]');
      box.innerHTML = '';
      list.forEach(function (x) {
        var row = el('div', 'mfy-send__item');
        var text = el('div', 'mfy-send__item-text');
        text.appendChild(el('div', 'mfy-send__item-name', x.title));
        text.appendChild(el('div', 'mfy-send__item-detail', x.detail));
        row.appendChild(text);
        row.appendChild(el('span', 'mfy-send__item-price', (x.from ? 'From ' : '') + money(x.price)));
        var rm = el('button');
        rm.type = 'button';
        rm.setAttribute('aria-label', 'Remove ' + x.title);
        rm.innerHTML = '<svg aria-hidden="true" viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M6 6l12 12M18 6L6 18"/></svg>';
        rm.addEventListener('click', function () {
          list = list.filter(function (y) { return y.key !== x.key; });
          saveList(); syncHearts(); renderBar();
        });
        row.appendChild(rm);
        box.appendChild(row);
      });
      send.querySelector('[data-mfy-send-total]').textContent = money(listTotal());
      var cta = send.querySelector('[data-mfy-send-cta]');
      cta.href = sendHref(sendMode);
      cta.textContent = sendMode === 'email' ? 'Open email' : 'Open messages';
      send.querySelector('[data-mfy-switch]').textContent = sendMode === 'email' ? 'Text it instead' : 'Email it instead';
    }
    function renderBar() {
      if (!bar) return;
      var count = list.length;
      var bagCount = cart ? cart.item_count : 0;
      var listRow = bar.querySelector('[data-mfy-row="list"]');
      var bagRow = bar.querySelector('[data-mfy-row="bag"]');
      listRow.hidden = bagCount > 0;
      bagRow.hidden = bagCount === 0;
      qsa('[data-mfy-list-count]', bar).forEach(function (b) { b.textContent = String(count); b.hidden = count === 0; });
      qsa('[data-mfy-bar-gem]', bar).forEach(function (g) { g.classList.toggle('is-on', count > 0); });
      bar.querySelector('[data-mfy-list-sum]').textContent = count === 0
        ? 'Tap the heart on any design to start'
        : count + (count === 1 ? ' design · ' : ' designs · ') + money(listTotal()) + ' · ' + barCount().toLowerCase();
      if (bagCount > 0) {
        bar.querySelector('[data-mfy-bag-count]').textContent = String(bagCount);
        bar.querySelector('[data-mfy-bag-total]').textContent = 'In your bag · ' + money(cart.total_price);
        var names = cart.items.map(function (i) { return i.product_title; });
        bar.querySelector('[data-mfy-bag-sum]').textContent = (justAdded ? 'Added: ' + justAdded : names.join(', ')) + ' · ' + barCount().toLowerCase();
        var lb = bar.querySelector('[data-mfy-list-btn]');
        if (lb) lb.setAttribute('aria-label', 'Your wishlist, ' + count + (count === 1 ? ' design' : ' designs'));
      }
      renderSend();
    }
    function refreshCart(addedTitle) {
      if (addedTitle) {
        justAdded = addedTitle;
        clearTimeout(justTimer);
        justTimer = setTimeout(function () { justAdded = null; renderBar(); }, 2400);
      }
      return fetch(rootUrl() + 'cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (c) { cart = c; renderBar(); })
        .catch(function () {});
    }

    /* ---------- Rail controls ---------- */
    function bindRail(wrap) {
      var track = wrap.querySelector('[data-mfy-track]');
      var ctrl = wrap.querySelector('[data-mfy-ctrl]');
      if (!track || !ctrl) return;
      var prev = ctrl.querySelector('[data-dir="-1"]');
      var next = ctrl.querySelector('[data-dir="1"]');
      var fill = ctrl.querySelector('.mfy-rail-ctrl__fill');
      var count = ctrl.querySelector('.mfy-rail-ctrl__count');
      function step() {
        var card = track.firstElementChild;
        if (!card) return 1;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return card.getBoundingClientRect().width + gap;
      }
      function update() {
        var n = track.children.length;
        var s = step();
        var visible = Math.max(1, Math.round((track.clientWidth + (parseFloat(getComputedStyle(track).columnGap) || 0)) / s));
        var i = Math.round(track.scrollLeft / s);
        var max = Math.max(0, n - visible);
        i = Math.min(i, max);
        fill.style.left = (i / n * 100) + '%';
        fill.style.width = (Math.min(visible, n) / n * 100) + '%';
        count.textContent = pad2(i + 1) + '–' + pad2(Math.min(i + visible, n)) + ' / ' + pad2(n);
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
        ctrl.hidden = track.scrollWidth <= track.clientWidth + 2;
      }
      [prev, next].forEach(function (b) {
        b.addEventListener('click', function () { track.scrollBy({ left: Number(b.dataset.dir) * step(), behavior: 'smooth' }); });
      });
      track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
      window.addEventListener('resize', update);
      update();
    }

    /* ---------- Reviews ---------- */
    function bindReviews(root) {
      var items = qsa('.mfy-review', root);
      var dots = qsa('.mfy-reviews__dots span', root);
      if (items.length < 2) return;
      var i = 0, hold = false;
      function show(k) {
        i = (k + items.length) % items.length;
        items.forEach(function (r, j) { r.classList.toggle('is-active', j === i); r.setAttribute('aria-hidden', j === i ? 'false' : 'true'); });
        dots.forEach(function (d, j) { d.classList.toggle('is-active', j === i); });
      }
      root.addEventListener('pointerenter', function () { hold = true; });
      root.addEventListener('pointerleave', function () { hold = false; });
      setInterval(function () { if (!hold && !document.hidden) show(i + 1); }, Number(root.dataset.interval) || 3500);
      show(0);
    }

    /* ---------- Your initial ---------- */
    function bindInitial(root) {
      var dataEl = root.querySelector('[data-mfy-initial-data]');
      if (!dataEl) return;
      var data;
      try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
      var state = { letter: root.dataset.letter || 'L', metal: 0 };
      var addBtn = root.querySelector('[data-mfy-initial-add]');
      var busy = false;
      function variant() {
        return data.variants.find(function (v) { return v.letter === state.letter && v.metal === data.metals[state.metal]; }) || null;
      }
      function render() {
        var v = variant();
        qsa('button[data-letter]', root).forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.letter === state.letter ? 'true' : 'false'); });
        qsa('[data-metal]', root).forEach(function (b) { b.setAttribute('aria-pressed', Number(b.dataset.metal) === state.metal ? 'true' : 'false'); });
        var img = root.querySelector('[data-mfy-letter-img]');
        if (img && data.letterImages[state.letter]) { img.src = data.letterImages[state.letter]; img.alt = 'The letter ' + state.letter + ', shown as a diamond'; }
        root.querySelector('[data-mfy-your]').textContent = 'Your ' + state.letter + ', bezel set';
        root.querySelector('[data-mfy-metal-name]').textContent = data.metals[state.metal];
        var details = root.querySelector('[data-mfy-initial-details]');
        if (details && v) details.href = data.url + '?variant=' + v.id;
        var heart = root.querySelector('[data-mfy-initial-heart]');
        if (heart && v) {
          heart.dataset.key = 'initial-' + state.letter + '-' + state.metal;
          heart.dataset.detail = 'Letter ' + state.letter + ', ' + data.metals[state.metal];
          heart.dataset.url = data.url + '?variant=' + v.id;
          heart.dataset.price = v.price;
          syncHearts();
        }
        if (!busy) {
          addBtn.disabled = !v || !v.available;
          addBtn.textContent = !v ? 'Unavailable' : v.available ? (data.addLabel + ' · ' + money(v.price)) : 'Sold Out';
        }
      }
      root.addEventListener('click', function (e) {
        var l = e.target.closest('button[data-letter]');
        if (l) { state.letter = l.dataset.letter; render(); return; }
        var m = e.target.closest('[data-metal]');
        if (m) { state.metal = Number(m.dataset.metal); render(); }
      });
      addBtn.addEventListener('click', function () {
        var v = variant();
        if (!v || !v.available || busy) return;
        busy = true;
        addBtn.classList.add('is-loading');
        addBtn.textContent = 'Adding';
        addToCart(v.id).then(function (item) {
          addBtn.classList.remove('is-loading');
          addBtn.textContent = 'Added to bag';
          try { document.dispatchEvent(new CustomEvent('sette:quick-add', { detail: { variantId: Number(v.id), handle: data.handle, item: item } })); } catch (e) {}
          openBag(addBtn);
          setTimeout(function () { busy = false; render(); }, 2400);
        }).catch(function (err) {
          addBtn.classList.remove('is-loading');
          addBtn.textContent = (err && err.message) ? 'Try again' : 'Try again';
          setTimeout(function () { busy = false; render(); }, 2400);
        });
      });
      render();
    }

    /* ---------- Wire up ---------- */
    function init() {
      bar = document.querySelector('[data-mfy-bar]');
      qsa('[data-mfy-media]').forEach(bindMedia);
      paintSwatches(document);
      qsa('[data-mfy-rail]').forEach(bindRail);
      qsa('[data-mfy-reviews]').forEach(bindReviews);
      qsa('[data-mfy-initial]').forEach(bindInitial);
      syncHearts();
      renderCountdown();
      refreshCart();
      renderBar();
      setInterval(function () { renderCountdown(); renderBar(); }, 30000);

      document.addEventListener('click', function (e) {
        var sw = e.target.closest('.mfy-sw');
        if (sw) { e.preventDefault(); pickSwatch(sw); return; }
        var h = e.target.closest('[data-mfy-heart]');
        if (h) { e.preventDefault(); toggleHeart(h); return; }
        if (!bar) return;
        var open = e.target.closest('[data-mfy-open]');
        if (open && bar.contains(open)) {
          var mode = open.dataset.mfyOpen || 'text';
          sendMode = sendMode === mode ? null : mode;
          renderBar();
          return;
        }
        if (e.target.closest('[data-mfy-close]')) { sendMode = null; renderBar(); return; }
        if (e.target.closest('[data-mfy-switch]')) { sendMode = sendMode === 'email' ? 'text' : 'email'; renderBar(); return; }
        var copy = e.target.closest('[data-mfy-copy]');
        if (copy) {
          var done = function () { copy.textContent = 'Copied'; setTimeout(function () { copy.textContent = 'Copy the list'; }, 2400); };
          try { navigator.clipboard.writeText(message()).then(done, function () {}); } catch (err) {}
          return;
        }
        var view = e.target.closest('[data-mfy-view-bag]');
        if (view) { e.preventDefault(); openBag(view); return; }
        if (sendMode && !e.target.closest('[data-mfy-send]')) { sendMode = null; renderBar(); }
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && sendMode) { sendMode = null; renderBar(); } });
      document.addEventListener('sette:quick-add', function (e) {
        var title = e.detail && e.detail.item && (e.detail.item.product_title || (e.detail.item.items && e.detail.item.items[0] && e.detail.item.items[0].product_title));
        setTimeout(function () { refreshCart(title || null); }, 300);
      });
      document.addEventListener('cart:updated', function () { refreshCart(); });
      document.addEventListener('visibilitychange', function () { if (!document.hidden) refreshCart(); });
      window.addEventListener('storage', function (e) { if (e.key === LIST_KEY) { list = readList(); syncHearts(); renderBar(); } });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();

})();
